import { Modal } from 'shared/ui/modal';
import { BasicCard } from 'shared/ui/cards/basicCard';
import { GridContainer } from './styles';
import { PersonBookProvider } from 'entities/person';
import { FC } from 'react';
import { BookingSystem } from './BookingSystem';
import { BookingProps } from '../types';

export const Booking: FC<BookingProps> = props => {
	const { usePersonBookProvider = true, zIndex = 1000 } = props;
	return (
		<Modal id="booking-form" zIndex={zIndex}>
			<BasicCard isRoundedCorners={false} variant={'secondary'}>
				<GridContainer>
					{usePersonBookProvider ? (
						<PersonBookProvider>
							<BookingSystem {...props} />
						</PersonBookProvider>
					) : (
						<BookingSystem {...props} />
					)}
				</GridContainer>
			</BasicCard>
		</Modal>
	);
};
